module.exports = __webpack_public_path__ + "img/Weapon_100.f2dd5168.png";